import { useSyncExternalStore } from 'react'
import { DESIGN_COPY } from './copy'
import { Segmented, type SegmentedOption } from './Segmented'
import {
  deviceStorage,
  getTypeScale,
  setTypeScale,
  subscribeTypeScale,
  TYPE_SCALES,
  type TypeScale,
} from './typeScale'

const OPTIONS: readonly SegmentedOption<TypeScale>[] = TYPE_SCALES.map((scale) => ({
  value: scale,
  label: <span className={`text-size-sample text-size-sample-${scale}`}>{DESIGN_COPY.textSizes[scale]}</span>,
}))

export const useTypeScale = (): TypeScale => useSyncExternalStore(subscribeTypeScale, getTypeScale, getTypeScale)

export const TypeScaleControl = () => {
  const scale = useTypeScale()
  const choose = (next: TypeScale) => setTypeScale(document.documentElement, deviceStorage(), next)

  return (
    <Segmented
      label={DESIGN_COPY.textSize}
      name="rp-type-scale"
      value={scale}
      options={OPTIONS}
      onChange={choose}
      layout="grid"
    />
  )
}
